import * as React from "react";
const SvgEraser20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "m11.033 1.913-9.24 9.24a3.295 3.295 0 0 0 0 4.65l2.53 2.53h14.375v-2h-7.415l7.08-7.08-7.33-7.34Zm0 2.83 4.51 4.51-7.08 7.08h-3.3l-1.95-1.95c-.24-.24-.38-.57-.38-.91 0-.34.13-.67.38-.91l1.093-1.093 3.57 3.57 1.414-1.414-3.57-3.57 5.313-5.313Z",
      clipRule: "evenodd"
    })
  );
export default SvgEraser20Px;
